import store from "../../store";
import { getADayFromDay, getADayFromNow } from "../../utils/date";
import { setDate, setMobileDate } from "./reducer";

export const setInitialDate = (dispatch)=>{
    const arr = [
        getADayFromNow(-4),
        getADayFromNow(-3),
        getADayFromNow(-2),
        getADayFromNow(-1),
        getADayFromNow(0),
        getADayFromNow(1),
        getADayFromNow(2),
        getADayFromNow(3),
        getADayFromNow(4),
    ];
    dispatch(setDate(arr));
}

export const addDate = (dispatch) => {
    const state = store.getState().date.dates;
    const stateMobile = store.getState().date.datesMobile;
    
    const prev = state.filter((e,i)=>i!==0);
    const prevMobile = stateMobile.filter((e,i)=>i!==0);
    
    prev.push(getADayFromDay(prev[prev.length-1],1));
    prevMobile.push(getADayFromDay(prevMobile[prevMobile.length-1],1));
    
    dispatch(setDate(prev));
    dispatch(setMobileDate(prevMobile));
}

export const removeDate = (dispatch) => {
    const state = store.getState().date.dates;
    const stateMobile = store.getState().date.datesMobile;
    
    const prev = state.filter((e,i)=>i!==(state.length-1));
    const prevMobile = stateMobile.filter((e,i)=>i!==(stateMobile.length-1));
    
    prev.unshift(getADayFromDay(prev[0],-1));
    prevMobile.unshift(getADayFromDay(prevMobile[0],-1));
    
    dispatch(setDate(prev));
    dispatch(setMobileDate(prevMobile));

}

export const setInitialMobileDate = (dispatch)=>{
    const arr = [
        getADayFromNow(-2),
        getADayFromNow(-1),
        getADayFromNow(0),
        getADayFromNow(1),
        getADayFromNow(2),
    ];
    dispatch(setMobileDate(arr));
}